import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const measurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-75PXYZJQP5';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyBU6AduLk9ZGEXk6UTxAJ_4aLi1yV-AYRQ',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'hack-8af01.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'hack-8af01',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'hack-8af01.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '1085311879135',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:1085311879135:web:40d9cfd7adf780f265a66a',
  ...(measurementId ? { measurementId } : {}),
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, 'europe-west1');
const googleProvider = new GoogleAuthProvider();
const isLocalDev =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
const shouldUseRemoteFunctions =
  !isLocalDev || process.env.REACT_APP_ENABLE_REMOTE_FUNCTIONS_IN_DEV === 'true';

const analyticsPromise = (() => {
  if (typeof window === 'undefined' || !measurementId) {
    return Promise.resolve(null);
  }

  return isSupported()
    .then((supported) => (supported ? getAnalytics(app) : null))
    .catch(() => null);
})();

function logAnalyticsEvent(eventName, eventParams = {}) {
  analyticsPromise.then((analytics) => {
    if (!analytics) {
      return;
    }

    logEvent(analytics, eventName, eventParams);
  });
}

function trackPageView(pathname, search = '') {
  if (typeof window === 'undefined') {
    return;
  }

  logAnalyticsEvent('page_view', {
    page_location: window.location.href,
    page_path: `${pathname}${search}`,
    page_title: document.title,
  });
}

googleProvider.setCustomParameters({ prompt: 'select_account' });

export {
  app,
  auth,
  db,
  storage,
  functions,
  googleProvider,
  isLocalDev,
  shouldUseRemoteFunctions,
  analyticsPromise,
  logAnalyticsEvent,
  trackPageView,
};
